import { render } from "./TableRecords.vue?vue&type=template&id=2b9ab2a6"
import script from "./TableRecords.vue?vue&type=script&lang=js"
export * from "./TableRecords.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__